import { Box, Button } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DescriptionIcon from '@mui/icons-material/Description';
import DashboardCard from '../common/DashboardCard';

function Billing(props: any) {
    const accentColor = props.accentColor;
    return (
        <DashboardCard
            title="Billing (Coming Soon)"
            icon={<CreditCardIcon />}
            accentColor={accentColor}
            actions={
                <Button
                    startIcon={<DescriptionIcon />}
                    onClick={() => console.log("click")}
                >
                    Invoice
                </Button>
            }
        >
            <Box sx={{ p: 2 }} />
        </DashboardCard>
    );
}

export default Billing;
